export function newTreeItem(
  id: number,
  displayName: string,
  order: number,
  selectable: boolean = null,
  filterOnSearch: boolean = null,
): object {
    return {
        id: id,
        displayName,
        order,
        selectable,
        visible: true,
        filterOnSearch,
    };
}
